import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["stroke"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 12 12",
    fill: "none"
  }, [_createElementVNode("path", {
    d: "M3.5 8.5L8.5 3.5M8.5 8.5V3.5H3.5",
    stroke: $props.color,
    "stroke-width": "0.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_2)], 8, _hoisted_1);
}